module.exports = __webpack_public_path__ + "static/media/redemption-gift-pouch.bee70a19.png";